import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IsentropicService } from '../../isentropic.service';


@Component({
    selector: 'app-if-machang',
    templateUrl: './if-machang.component.html',
    styleUrl: './if-machang.component.scss',
    standalone: false
})
export class IfMachangComponent implements OnInit {

  maForm: FormGroup | undefined;
  maBool?: boolean;
  macha:number = 0;
  ma:string  = '';
  ga:number = 0;
  machMap?: Map<string, number>;

  constructor(private isentropicService: IsentropicService, private fBuilder: FormBuilder) { }

  ngOnInit() {
    this.maForm = this.fBuilder.group({
      maVal: ['', [
        Validators.required,
        Validators.min(0),
        Validators.max(90.000001)
      ]],
      gammaVal: ['', [
        Validators.required,
        Validators.min(1.000001),
        Validators.max(1.67)
      ]]
    })
  }

  mach_from_mu(m_ang:number) {
    let ma = Number(m_ang);
    let ma_rad = (m_ang / 180) * Math.PI;
    return (1 / Math.sin(ma_rad)).toFixed(2);
  }

  onSubmit(): void {
    this.maBool = true;
    this.macha = this.maForm?.get('maVal')?.value;
    this.ga = this.maForm?.get('gammaVal')?.value;

    // console.log(this.macha, this.ga);
    this.ma = this.mach_from_mu(this.macha);
    const machNum = Number(this.ma);
    this.machMap = this.isentropicService.getIsentropic(this.ga, machNum);
  }

  isenMach() {
    return this.ma;
  }

  isenp_pt() {
    return this.machMap?.get("p_pt");
  }

  isenT_Tt() {
    return this.machMap?.get("T_Tt");
  }

  isenA_As() {
    return this.machMap?.get("A_A*")
  }

  isenpA_ptAstar() {
    return this.machMap?.get("pA_ptA*");
  }

  isen_cfopt() {
    return this.machMap?.get("C_Fopt");
  }

  isen_rhot() {
    return this.machMap?.get("rho/rhot");
  }

}
